import { render } from "./CleanersList.vue?vue&type=template&id=1a285cf0&ts=true"
import script from "./CleanersList.vue?vue&type=script&lang=ts"
export * from "./CleanersList.vue?vue&type=script&lang=ts"

import exportComponent from "/home/viper/Projects/topway/topway-accounting-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__